// external
import styled from 'styled-components';

export const VEHICLE_LIST_ITEM_WIDTH = '319px';

export const VehicleColumnListItemsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: ${({ theme }) => theme.tokens.ComponentCardBorderRadius};
    border: 1px solid ${({ theme }) => theme.tokens.BaseColorGray300};
    overflow: hidden;
`;

export const SearchResultHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: end;
    margin-top: ${({ theme }) => theme.tokens.BaseSpace40};
    margin-bottom: ${({ theme }) => theme.tokens.BaseSpace40};
`;
